import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-96f60926"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "tree-node" };
const _hoisted_2 = {
    key: 0,
    class: "line"
};
const _hoisted_3 = {
    key: 0,
    class: "children"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Icon = _resolveComponent("Icon");
    const _component_TreeNode = _resolveComponent("TreeNode", true);
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
            class: "node-content mb-1",
            style: _normalizeStyle({ paddingLeft: _ctx.paddingLeft })
        }, [
            (_ctx.level > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.node.title) + " ", 1),
            (_ctx.level === 0 && _ctx.shouldCascade)
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 1,
                    class: "ml-2",
                    title: _ctx.tr('viiu.componentMuting.AFFECTED_COMPONENT_TOOLTIP'),
                    name: "warning2"
                }, null, 8, ["title"]))
                : _createCommentVNode("", true)
        ], 4),
        (_ctx.node.children.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.node.children, (child, index) => {
                    return (_openBlock(), _createBlock(_component_TreeNode, {
                        key: index,
                        node: child,
                        level: _ctx.level + 1,
                        "should-cascade": _ctx.shouldCascade
                    }, null, 8, ["node", "level", "should-cascade"]));
                }), 128))
            ]))
            : _createCommentVNode("", true)
    ]));
}
